<template>
	<div>
		<div v-for="err in _param.split(',').map(item => item.trim())" v-bind:key="err">
			<div class="validator is-size-7" v-if="_errors.indexOf(err) > -1">
				<span>{{ $t('validator.' + err) }}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Validator',
	props: {
		_errors: null,
		_param: null,
	},
	mounted() {},
}
</script>
